<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <div class="container">
          <h1>發佈參展商影音</h1>
          <p class="my-3">&nbsp;</p>
          <div class="alert alert-light text-dark" role="alert">
            <p>
              <i class="fas fa-exclamation-circle"> </i>
              請勿上傳與本展無關或是妨害社會善良風俗之內容，主辦單位有權刪除不適當的內容。
            </p>
          </div>
          <p class="my-3">&nbsp;</p>

          <form id="form" @submit.prevent="TwCnAddNewVideo">
            <input type="hidden" name="RegNo" />

            <p class="clear"></p>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle">影音主旨 <span class="red">*</span></p>
            <div class="langTip">
              <input type="text" name="NewsTopic" class="maxText textStyle" maxlength="50" v-model="VideoTopic" />
              <span>中 </span>
            </div>
            <div id="error1"></div>

            <p class="divider"></p>
            <div class="langTip">
              <input type="text" name="eNewsTopic" class="maxText textStyle" maxlength="50" v-model="eVideoTopic" />
              <span>EN</span>
            </div>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle">影片連結 <span class="red">*</span></p>

            <div>
              <label
                ><input type="radio" name="videoType" v-model="videoType" value="3" class="largeItem" checked />
                Youtube</label
              >
              <label
                ><input type="radio" name="videoType" v-model="videoType" value="4" class="largeItem ml-2" />
                Youku</label
              >
            </div>

            <div class="form-group videoLink">
              <div class="PcDevice">
                <div class="d-flex align-items-center" v-if="videoType == 3">
                  <div class="text-nowrap">https://www.youtube.com/watch?v=</div>
                  <input type="text" class="smallText textStyle" maxlength="15" v-model="videoLink" id="videoAdd3" />
                </div>

                <div class="d-flex align-items-center" v-if="videoType == 4">
                  <div class="text-nowrap">https://v.youku.com/v_show/id_</div>
                  <input
                    type="text"
                    class="smallText textStyle"
                    maxlength="15"
                    v-model="videoLink_Youku"
                    id="videoAdd4"
                  />
                  <span> ==.html </span>
                </div>
              </div>
              <div class="MbDevice">
                <div v-if="videoType == 3">
                  <div class="text-nowrap">https://www.youtube.com/watch?v=</div>
                  <input type="text" class="smallText textStyle" maxlength="15" v-model="videoLink" id="videoAdd3" />
                </div>

                <div v-if="videoType == 4">
                  <div class="text-nowrap">https://v.youku.com/v_show/id_</div>
                  <input
                    type="text"
                    class="smallText textStyle"
                    maxlength="15"
                    v-model="videoLink_Youku"
                    id="videoAdd4"
                  />
                  <span> ==.html </span>
                </div>
              </div>
            </div>
            <div id="error2"></div>
            <p class="my-3">&nbsp;</p>
            <div class="d-flex justify-content-center">
              <input type="submit" value="確定送出" class="btnStyle mr-4" />
              <a :href="`onlineExpoVideoList?no=${RegNo}`" class="btn btn-secondary iframeForm">返回</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    data() {
      return {
        RegNo: '',
        videoList: [],
        videoID: '',
        videoData: [],

        videoType: 3,
        VideoTopic: '',
        eVideoTopic: '',
        videoLink: '',
        videoLink_Youku: '',
        VideoContent: '',
        videoArchive: '0',
        show: false,
        CSRF_Token: '',
        VideoAmount: 0,
        VideoPub: 0,
        lang: 'tw',
        date: '',

        UploadvideoID: '',
        Serno: '',

        //判斷各頁狀態儀表版值
        OnlineExpolayoutStatus: '',
        PressReleaseStatus: '',
        VideoStatus: '',
        ProductStatus: '',
        BasicinformationStatus: '',

        //判斷儀表板是否有線上展
        HasOnlineExpo: '',
        openOnlineExpo: '',
        showOnlineStatus: false,
      }
    },

    watch: {
      videoLink() {
        if (this.videoLink_Youku && this.videoLink) {
          this.videoLink_Youku = ''
        } else {
          let YtDelSpace = this.videoLink.trim()
          this.videoLink = YtDelSpace
        }
      },

      videoLink_Youku() {
        if (this.videoLink_Youku && this.videoLink) {
          this.videoLink = ''
        } else {
          let YkDelSpace = this.videoLink_Youku.trim()
          this.videoLink_Youku = YkDelSpace
        }
      },
    },

    methods: {
      closefancybox() {
        parent.$.fancybox.close()
      },
      toVideolink() {
        vm.closefancybox()
        parent.window.location = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${RegNo}`
      },

      toEnVideolink() {
        vm.closefancybox()
        parent.window.location = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${RegNo}`
      },

      deleteVideo(id) {
        const vm = this

        if (vm.lang == 'tw') {
          if (confirm('請確認要刪除此筆影音嗎？')) {
            const info = {
              CSRF: vm.CSRF_Token,
            }

            const url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}?VideoNo=${id}`

            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('您選擇的參展商影音已刪除成功！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          } else {
            return false
          }
        } else {
          if (confirm('Delete this video?')) {
            const info = {
              CSRF: vm.CSRF_Token,
            }

            const url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}?VideoNo=${id}`

            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Video successfully deleted! ')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              } else if (response.data.Code == 500) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              }
            })
          } else {
            return false
          }
        }
      },
      updateVideo() {
        const vm = this
        const url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}/${vm.videoID}`
        const info = {
          VideoTopic: vm.videoData.VideoTopic,
          eVideoTopic: vm.videoData.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: vm.videoData.archive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.videoData.VideoTopic) {
          alert('輸入欄位不完整，請重新檢查！')
          $('#error1').html("<span class='errorTextArea'>請填寫此欄位</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>請填寫此欄位</span>")
          }
        } else if (vm.videoData.VideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>請填寫此欄位</span>")
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('您已成功修改影音內容！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      updateEnVideo() {
        const vm = this
        const url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}/${vm.videoID}`
        const info = {
          // RegNo: vm.RegNo,
          VideoTopic: vm.videoData.VideoTopic,
          eVideoTopic: vm.videoData.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: vm.videoData.archive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.videoData.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.videoData.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully changed video information! ')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              } else if (response.data.Code == 500) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              }
            })
          }
        }
      },

      editVideo(id) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/videoEdit?no=${vm.RegNo}&id=${id}`
      },

      editVideoEn(id) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/videoEdit?no=${vm.RegNo}&id=${id}`
      },

      backVideoPage() {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
        }
      },

      toVidoeAdd() {
        const vm = this
        if (vm.VideoAvailable > 0) {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/videoAdd?no=${vm.RegNo}`
        } else {
          alert(`您已發佈 ${vm.VideoPub} 則參展商影音，如需發佈更多影音資訊，請至加值服務方案查看升級辦法。`)
        }
      },

      toEnVidoeAdd() {
        const vm = this
        if (vm.VideoAvailable > 0) {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/videoAdd?no=${vm.RegNo}`
        } else {
          alert(`You have published ${vm.VideoPub} video(s). Want to publish more video? Please check Paid Services.`)
        }
      },

      AddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        // // console.log(vm.videoLink)

        // let analyvideoLink = vm.videoLink.trim()

        // // console.log(analyvideoLink)

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: vm.videoArchive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.VideoTopic) {
          alert('輸入欄位不完整，請重新檢查！')
          $('#error1').html("<span class='errorTextArea'>請填寫此欄位</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>請填寫此欄位</span>")
          }
        } else if (vm.VideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('輸入欄位不完整，請重新檢查！')
            $('#error1').empty("<span class='errorTextArea'>請填寫此欄位</span>")
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('您已成功新增影音！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      AddEnNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,

          Archived: vm.videoArchive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully published video!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              } else if (response.data.Code == 500) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              }
            })
          }
        }
      },

      TwCnAddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: vm.videoArchive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.VideoTopic) {
          alert('輸入欄位不完整，請重新檢查！')
          $('#error1').html("<span class='errorTextArea'>請填寫此欄位</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>請填寫此欄位</span>")
          }
        } else if (vm.VideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>請填寫此欄位</span>")
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('您已成功新增影音！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      EnEnAddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: 0,
          CSRF: vm.CSRF_Token,
          origin: 'ExpoVideo',
        }

        if (!vm.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully published video!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 251) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 252) {
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 500) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              }
            })
          }
        }
      },

      TwEnAddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: 0,
          CSRF: vm.CSRF_Token,
          origin: 'ExpoVideo',
        }

        if (!vm.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully published video!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 251) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 252) {
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 500) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              }
            })
          }
        }
      },

      EnCnAddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: 0,
          CSRF: vm.CSRF_Token,
          origin: 'ExpoVideo',
        }

        if (!vm.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully published video!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_zhtw_onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 251) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 252) {
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 500) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              }
            })
          }
        }
      },

      eSaveOnlineVideo() {
        const vm = this
        const url = '/apiExhibitors/EditOnlineExhibitionVideo/'

        const info = {
          RegNo: vm.RegNo,
          videoID: vm.UploadvideoID,
          CSRF: vm.CSRF_Token,
        }

        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 251) {
            alert('System is busy, please try again later.')
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 252) {
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 253) {
            alert(' Please choose one video and click SAVE for your latest update')
            // vm.closefancybox()
            // parent.window.location.reload()
          } else if (response.data.Code == 500) {
            alert('System is busy, please try again later.')
            vm.closefancybox()
            parent.window.location.reload()
          }
        })
      },

      saveOnlineVideo() {
        const vm = this
        const url = '/apiExhibitors/EditOnlineExhibitionVideo/'

        const info = {
          RegNo: vm.RegNo,
          videoID: vm.UploadvideoID,
          CSRF: vm.CSRF_Token,
        }

        axios.post(url, info).then(function (response) {
          // console.log(response.data.Code)
          if (response.data.Code == 200) {
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 251) {
            alert('系統忙碌，請稍後再試！')
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 252) {
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 253) {
            alert('請先選擇攤位播放影片再按下儲存！')
            // vm.closefancybox()
            // parent.window.location.reload()
          } else if (response.data.Code == 500) {
            alert('系統忙碌，請稍後再試！')
            vm.closefancybox()
            parent.window.location.reload()
          }
        })
      },
    },

    computed: {
      VideoAvailable() {
        const vm = this
        return vm.VideoAmount - vm.VideoPub
      },
    },

    created() {
      const vm = this

      //取得語系

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]
      vm.videoID = currentUrl.split('id=')[1]

      // console.log(vm.RegNo)

      //url取載入頁面參數

      if (vm.lang == 'tw') {
        var getHtmlurl = currentUrl.split('/')[4]
        var HtmlName = getHtmlurl.split('?')[0]
      } else {
        //url取英文載入頁面參數
        var getEnHtmlurl = currentUrl.split('/')[5]
        var HtmlEnName = getEnHtmlurl.split('?')[0]
      }

      //取得時間
      let theDate = new Date()
      vm.date = `${theDate.getFullYear()}/${theDate.getMonth() + 1}/${theDate.getDate()}`

      //影片額度
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        // console.log(response)

        vm.HasOnlineExpo = response.data.Data.Virtual

        vm.VideoAmount = response.data.Data.VideoAmount

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus
        vm.VideoStatus = response.data.Data.VideoStatus
        vm.ProductStatus = response.data.Data.ProductStatus
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus

        //取得是否開啟線上展權限
        axios
          .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`)
          .then((response) => {
            // console.log(response.data.Data)

            vm.openOnlineExpo = response.data.Data.OnlineExpo_Archived

            if (vm.openOnlineExpo == 1 && vm.HasOnlineExpo == 1) {
              vm.showOnlineStatus = true
            } else {
              vm.showOnlineStatus = false
            }
          })
      })

      //取得線上展總資料
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/DisplayOnlineExpoControl/${vm.RegNo}`).then((response) => {
        if (response.data.Data) {
          vm.UploadvideoID = response.data.Data.VideoID
          vm.Serno = response.data.Data.Serno
        }
      })

      //判定當前網頁網址
      if (
        HtmlName == 'video' ||
        HtmlEnName == 'video' ||
        HtmlName == 'onlineExpoVideoList' ||
        HtmlName == 'onlineVideoAdd' ||
        HtmlName == 'oversea_onlineExpoVideoList' ||
        HtmlEnName == 'onlineExpoVideoList' ||
        HtmlEnName == 'onlineVideoAdd' ||
        HtmlName == 'oversea_zhtw_onlineExpoVideoList'
      ) {
        let url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}?Page=1`
        axios.get(url).then(function (response) {
          // console.log(response.data)

          if (response.data.Data.length > 0) {
            vm.videoList = response.data.Data
            vm.VideoPub = response.data.datatotal

            vm.show = true
          } else {
            vm.show = false
          }
        })
      } else if (HtmlName == 'videoEdit' || HtmlEnName == 'videoEdit') {
        let url2 = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}/${vm.videoID}`
        axios
          .get(url2)
          .then(function (response) {
            // console.log(response.data.Data)

            if (response.data.Data) {
              vm.videoData = response.data.Data
              vm.videoLink = response.data.Data.videoLink
              vm.videoLink_Youku = response.data.Data.videoLink_Youku

              if (response.data.Data.videoLink) {
                vm.videoType = 3
              } else if (response.data.Data.videoLink_Youku) {
                vm.videoType = 4
              }
            } else {
              alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
            }
          })
          .catch((err) => {
            alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
          })
      }
    },
  }
</script>

<style lang="scss"></style>
